<style lang="scss">
  @use "../../../../../assets/css/global.scss" as *;
  @use "../../../../../assets/css/_colors.scss" as *;
  .progress-container {
    display: flex;
    justify-content: center;
    max-width: 600px;
    margin: 0rem auto 2rem;
    gap: 1rem;

    .progress-lines {
      display: flex;
      align-items: center;

      .line {
        width: 50px;
        height: 6px;
        background-color: $light-gray;
        margin: 0 8px;
        border-radius: 0.5rem;
        position: relative;
        overflow: hidden;

        .fill {
          position: absolute;
          top: 0;
          left: 0;
          width: 100%;
          height: 100%;
          background-color: $primary-color;
        }
      }
    }

    .nav-button {
      &:hover {
        opacity: 0.7;
      }
      color: $primary-color;
      background: 0;
      border: 0;

      &.invisible {
        visibility: hidden;
      }

      i {
        margin: 0rem 0.5rem;
      }
    }
  }
</style>

<script>
  import { slide } from "svelte/transition";

  export let currentStep = 0;
  export let totalSteps = 0;

  const nextStep = () => {
    if (currentStep < totalSteps - 1) {
      currentStep += 1;
    }
  };

  const prevStep = () => {
    if (currentStep > 0) {
      currentStep -= 1;
    }
  };
</script>

<div class="progress-container">
  {#if currentStep > 0}
    <button class="nav-button" on:click={prevStep}>
      <i class="fa-solid fa-chevron-left"></i> BACK
    </button>
  {:else}
    <button class="nav-button invisible">
      <i class="fa-solid fa-chevron-left"></i> BACK
    </button>
  {/if}

  <div class="progress-lines">
    {#each Array(totalSteps) as _, index}
      <span class="line">
        {#if index <= currentStep}
          <div
            class="fill"
            transition:slide|local={{ duration: 300, axis: "x" }}
          ></div>
        {/if}
      </span>
    {/each}
  </div>

  {#if currentStep < totalSteps - 1}
    <button class="nav-button" on:click={nextStep}>
      NEXT <i class="fa-solid fa-chevron-right"></i>
    </button>
  {:else}
    <button class="nav-button invisible">
      NEXT <i class="fa-solid fa-chevron-right"></i>
    </button>
  {/if}
</div>
